<template>
    <router-link to="/cart" class="relative inline-block">
        <button :class="[
            'flex items-center justify-center rounded-lg font-semibold transition-all duration-300 relative',
            sizeClasses,
            disabled ? 'bg-gray-500 cursor-not-allowed' : ''
        ]" :disabled="disabled">
            <!-- Icon Keranjang -->
            <AppIcon icon="mdi:cart" class="w-6 h-6" />
            <!-- Badge -->
            <span v-if="showBadge && badgeCount > 0"
                class="absolute top-0 right-0 transform translate-x-1 -translate-y-1 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
                {{ badgeCount }}
            </span>
        </button>
    </router-link>
</template>

<script>
export default {
    name: "BaseCartButton",
    props: {
        badgeCount: {
            type: Number,
            default: 0, // Jumlah badge (item di cart)
        },
        size: {
            type: String,
            default: "medium", // Ukuran tombol: 'small', 'medium', atau 'large'
            validator: (value) => ["small", "medium", "large"].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false, // Jika tombol dinonaktifkan
        },
        showBadge: {
            type: Boolean,
            default: true, // Apakah badge akan ditampilkan
        },
    },
    computed: {
        sizeClasses() {
            switch (this.size) {
                case "small":
                    return "px-3 py-2 text-sm";
                case "large":
                    return "px-6 py-3 text-lg";
                default:
                    return "px-4 py-2";
            }
        },
    },
};
</script>

<style scoped>
/* No additional CSS required, styling is handled by Tailwind CSS */
</style>